module.exports = __webpack_public_path__ + "static/images/containers/BattleRooms/components/FullSchedule/images/background.710bc7bb.jpg";


//////////////////
// WEBPACK FOOTER
// ./containers/BattleRooms/components/FullSchedule/images/background.jpg
// module id = 2738
// module chunks = 11